const CONSTANTS = require('../../lib/constants');
const utils     = require('../../lib/utils')

module.exports = {
	config: {
		focusAble:    true,
		// environmentDependent: true,
		startWithRegisterSecret: '',
		hideHeadContainingOneSingleElement: false,
		headerTagFormMapping: false, // mainly used for headlines at the moment. works like the formMapping-element "tag" of forms.
		headerDescriptionKey: false, // directly before the accordion a description may be shown via this i18next key.
		addRelationshipElementButtonsFormMapping: false,

		defaultElementTitleKey: '' // in case of a static default title of an accordion-element's header this i18next key may be used to define it.
	},

	actions: {
		addElement: {
			type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
			source: {
				elementContainer: {
					componentData: {
						type: 'component',
						subType: 'layout', // TODO: PERFORMANCE IMPROVEMENT? maybe something around shadowComponentIdentification process.
						component: [
							'base',
							'accordion',
							'element'
						],
					}
				},
				load: {
					componentData: {
						config: {
							lastMileSelector: '.content'
						}
					},
					setParentViaActionSourceKey: 'elementContainer'
				}
			},
			target: {
				element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF,
				position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND
			}
		},
	},

	model: {
		activeRegisterSecret: '',
		actualNrOfDynamicElements: 0,
		removeElementWhenReady: {}
	},

	methods: {

		/**
		 * this function is used to perform the needed load actions for an element extended by selective data from the original action given.
		 *
		 * @param   data                                    mixed - PromiseContext of element-action
		 * @returns int                                     registerSecret of the new element
		 */
		addElement: function(data){
			// init
			var self = this;
			var nextRegisterSecret = this.model.actualNrOfDynamicElements++;

			data.action.source.element = data.action.source.element || {}
			data.action.source.element.componentData = data.action.source.element.componentData || {}
			data.action.source.element.componentData.originalActionParentComponentIndex = data.component.componentIndex
			data.action.source.element.componentData.originalParentActionKey = data.action.key

			data.action.source.elementContainer = data.action.source.elementContainer || {}
			data.action.source.elementContainer.componentData = data.action.source.elementContainer.componentData || {}
			data.action.source.elementContainer.componentData.originalActionParentComponentIndex = data.component.componentIndex
			data.action.source.elementContainer.componentData.originalParentActionKey = data.action.key
			data.action.source.elementContainer.componentData.config = utils.replace(data.action.source.elementContainer.componentData.config || {}, {
				bootstrapVersion: this.config.bootstrapVersion,
				registerSecret: nextRegisterSecret
			})

			// this is necessary to preserve the order of dynamic tabs in cases where later added tabs may be ready sooner than earlier added ones.
			const actionKey = `addElement_${this.getNextActionIndex()}`
			const lastUsedActionKey = self.model.lastUsedActionKey
			self.model.lastUsedActionKey = actionKey

			let defaultElementTitle = 'TITLE NOT DEFINED'
			if(self.config.defaultElementTitleKey){
				defaultElementTitle = storage.__(self.config.defaultElementTitleKey)
				data.action.source.elementContainer.componentData.config 				= data.action.source.elementContainer.componentData.config || {}
				data.action.source.elementContainer.componentData.config.static 		= data.action.source.elementContainer.componentData.config.static || {}
				data.action.source.elementContainer.componentData.config.static.title 	= defaultElementTitle
			}

			return this.performAndStoreAction(
				actionKey,
				this.prepareAction(
					'addElement',
					undefined,
					data.action.source.element.resourceRegister,
					{
						source: {
							elementContainer: {
								componentData: 			data.action.source.elementContainer.componentData,
								resourceRegisterKey: 	data.action.source.element.resourceRegisterKey,
							},
							load: data.action.source.element,
						},
						waitForActionID: lastUsedActionKey
					}
				)
			).then(function(data){
				// save accordion connection
				data.action.accordionConnection = {
					accordionComponentIndex: self.componentIndex,
					elementRegisterSecret: nextRegisterSecret
				};

				// extend registry by tabContent-component
				this.registry = this.registry || {}
				const registry = this.registry[nextRegisterSecret] || {}
				const actionSource = (data.action || {}).source || {}
				if(actionSource.load.component){
					registry.element = actionSource.load.component
				} else {
					const componentTree = actionSource.load.componentTree || {}
					if(componentTree.childLayoutIndex !== undefined && (componentTree.children || [])[componentTree.childLayoutIndex]){
						registry.element = componentTree.children[componentTree.childLayoutIndex]
					} else {
						console.error('could not register accordion.element via action.source.load')
					}
				}

				// focus new element if granted
				if((registry.element.resourceData || {}).grantAutoFocus !== false){
					self.focusElement(nextRegisterSecret);
				}

				self.updateStates();

				// return promise data
				return utils.promise.resolve(data);
			}).fail(function(data){
				data.action.accordionConnection = {
					accordionComponentIndex: self.componentIndex,
					elementRegisterSecret: nextRegisterSecret
				};

				// cleanup dynamic action components and it's actions in case of an error
				utils.forEach(self.actions, function(action, actionKey){
					if(
						action.source.elementContainer &&
						action.source.elementContainer.component &&
						action.source.elementContainer.component.config.registerSecret != undefined &&
						action.source.elementContainer.component.config.registerType != undefined &&
						(
							!self.registry[action.source.elementContainer.component.config.registerSecret] ||
							!self.registry[action.source.elementContainer.component.config.registerSecret][action.source.load.component.config.registerType]
						)
					){
						action.source.elementContainer.component.destroy();
					}
				});

				return utils.promise.reject(data);
			});
		},

		/**
		 * this function is used to destroy an element inclusive it's contents completely
		 *
		 * @param registerSecret
		 * @param [restoreActiveElement=false]
		 */
		removeElement: function(registerSecret, restoreActiveElement = false){
			// for deactivation issues focus element before actual element destruction.
			var registryKeys = Object.keys(this.registry);
			var restoreRegisterSecret;
			if(restoreActiveElement){
				restoreRegisterSecret = this.model.activeRegisterSecret;
			}

			if(registryKeys.length > 0){
				if(registerSecret == this.model.activeRegisterSecret || this.model.activeRegisterSecret == ''){
					registryKeys = this.getSortedRegisterSecrets();
					var lastRegistryKey = registryKeys.pop();
					if(lastRegistryKey == registerSecret){
						if(registryKeys.length > 0){
							lastRegistryKey = registryKeys.pop();
						}
						else {
							if((this.registry[lastRegistryKey] || {}).elementContainer){
								this.registry[lastRegistryKey].elementContainer.deactivate(true)
							}
							lastRegistryKey = undefined;
						}
					}
					if(lastRegistryKey != undefined) this.focusElement(restoreRegisterSecret !== undefined ? restoreRegisterSecret : lastRegistryKey);
				}
				else {
					this.focusElement(this.model.activeRegisterSecret);
				}
			} else if(!this.config.isReady){
				this.model.removeElementWhenReady[registerSecret] = true
			}

			// destroy element which should be removed
			if(registerSecret != undefined && this.registry[registerSecret]){
				// NOTE:    the Component.prototype.destroy() method is able to remove parents' registry entries if they are empty.
				//          so this doubled proofing of the registry entry is necessary sometimes.
				//          (e.g., in case of an action rollback because of an error during element content load)
				// NOTE: 	tabContent is present within the registry if and only if this was a dynamic loaded tab. if the tabContent has been created within the cms as tree element, the tabContent-component is a real child of the tabContentContainer.
				if(this.registry[registerSecret] && this.registry[registerSecret].elementContainer)    	this.registry[registerSecret].elementContainer.remove();
				if(this.registry[registerSecret] && this.registry[registerSecret].element)    			this.registry[registerSecret].element.destroy();
			}

			this.updateStates();
		},

		/**
		 * hide a element identified by registerSecret.
		 *
		 * @param   registerSecret        int - registerSecret
		 */
		hideElement: function(registerSecret){
			var components = (this.registry || {})[registerSecret];
			if(components){
				components.elementContainer.$.css({
					width: 0,
					height: 0,
					padding: 0,
					margin: 0,
					'border-width': 0,
					opacity: 0,
					overflow: 'hidden'
				});
			}
		},

		/**
		 * removes all elements from this accordion.
		 */
		clearElements: function(){
			this.model.actualNrOfDynamicElements = 0;

			for(const registerSecret in this.registry){
				// NOTE:    the Component.prototype.destroy() method is able to remove parents' registry entries if they are empty.
				//          so this doubled proofing of the registry entry is necessary sometimes.
				//          (e.g., in case of an action rollback because of an error during element load)
				// NOTE: 	element is present within the registry if and only if this was a dynamic loaded element. if the element has been created within the cms as tree element, the element-component is a real child of the elementContainer.
				if(this.registry[registerSecret] && this.registry[registerSecret].elementContainer)    	this.registry[registerSecret].elementContainer.remove();
				if(this.registry[registerSecret] && this.registry[registerSecret].element)    			this.registry[registerSecret].element.destroy();
			}
		},

		/**
		 * this function is used to focus an element identified by the given registerSecret.
		 *
		 * @param   registerSecret        				int - registerSecret
		 * @param   [forceElementFocusGranted=false]    boolean - check if focus element is granted or not
		 * @returns boolean - success (may be false if element not found according to given registerSecret)
		 */
		focusElement(registerSecret, forceElementFocusGranted = false){
			if(!forceElementFocusGranted && !this.focusElementGranted(registerSecret)) return false;

			this.model.activeRegisterSecret = registerSecret;

			utils.forEach(this.registry, function(registerElement, registerElementSecret){
				if(registerSecret != registerElementSecret){
					if(registerElement.elementContainer){
						registerElement.elementContainer.deactivate();
					}
				}
			});

			if(registerSecret != undefined && this.registry[registerSecret]){
				if(this.registry[registerSecret].elementContainer){
					this.registry[registerSecret].elementContainer.activate();
				}

				return true;
			}

			return false;
		},

		/**
		 * check if focus of element identified by registerSecret is granted or not.
		 *
		 * @param registerSecret
		 * @returns {boolean}
		 */
		focusElementGranted(registerSecret){
			// NOTE: overwrite if necessary
			return true
		},

		/**
		 * this function is used to focus the next available element in the actual element list
		 * NOTE: if the last element is the actual one, the first element will be focused.
		 */
		focusNextElement: function(){
			let elementSecrets, activationElementRegisterSecret;
			if(this.model.activeRegisterSecret == undefined){
				elementSecrets = Object.keys(this.registry);
				if(elementSecrets.length > 0) activationElementRegisterSecret = elementSecrets.shift();
			}
			else {
				elementSecrets = Object.keys(this.registry);
				const nextElementSecretIndex = elementSecrets.indexOf(this.model.activeRegisterSecret) + 1;
				if(elementSecrets.length > nextElementSecretIndex && nextElementSecretIndex >= 0) activationElementRegisterSecret = elementSecrets[nextElementSecretIndex];
			}

			if(activationElementRegisterSecret != undefined) this.focusElement(activationElementRegisterSecret);
		},

		/**
		 * this function is used to focus the previous available element in the actual element list.
		 * NOTE: if the first element is the actual one, the last element will be focused.
		 */
		focusPreviousElement: function(){
			let elementSecrets, activationElementRegisterSecret;
			if(this.model.activeRegisterSecret == undefined){
				elementSecrets = Object.keys(this.registry);
				if(elementSecrets.length > 0) activationElementRegisterSecret = elementSecrets.pop();
			}
			else {
				elementSecrets = Object.keys(this.registry);
				const nextElementSecretIndex = elementSecrets.indexOf(this.model.activeRegisterSecret) - 1;
				if(elementSecrets.length > nextElementSecretIndex && nextElementSecretIndex >= 0) activationElementRegisterSecret = elementSecrets[nextElementSecretIndex];
			}

			if(activationElementRegisterSecret != undefined) this.focusElement(activationElementRegisterSecret);
		},

		/**
		 * this function is used to mark an element with the given type.
		 *
		 * @param registerSecret		mixed - register secret of element which should be marked
		 * @param type					string - mark type (at the moment: "validationError" | <empty string>)
		 * @param addType				boolean - add or remove type-mark
		 */
		markElement: function(registerSecret, type, addType){
			let elementComponent;
			if(type !== undefined && registerSecret !== undefined && this.registry[registerSecret] && (elementComponent = this.registry[registerSecret].elementContainer)){
				elementComponent.mark(type, addType);
			}
		},

		/**
		 * this function refreshes an element head and an element content component identified by the registerSecret and replaces the headOptions within the element-Component if necessary.
		 *
		 * @param registerSecret		int - register secret identifying the element
		 * @param headOptions			object - optional - headOptions used for element head refresh
		 * @param refreshElementContent boolean - default: false - should the elementContent component be refreshed too?
		 */
		refreshElement: function(registerSecret, headOptions, refreshElementContent){
			const components = (this.registry || {})[registerSecret];
			if(components){
				utils.refReplace(components.elementContainer.model.headOptions, headOptions || {});
				if(refreshElementContent){
					components.elementContainer.refresh();
				} else {
					// TODO: CHECK IF THIS WORKS since element is not a child of elementContainer
					components.elementContainer.find('base_accordion_head', head => {
						utils.refReplace(head.model.headOptions, headOptions || {});
						head.refresh(false)
					})
				}
			}
		},

		/**
		 * returns the elementContainer component if possible or false otherwise
		 *
		 * @param registerSecret
		 * @returns {*|boolean}
		 */
		getElement: function(registerSecret){
			if(registerSecret === undefined) return false;
			const components = (this.registry || {})[registerSecret];
			if(components){
				return components.elementContainer
			}
			return false
		},

		/**
		 * returns elementContentCopmonent if possible or false otherwise
		 *
		 * @param registerSecret
		 * @returns {*|boolean}
		 */
		getElementContentComponent: function(registerSecret){
			if(registerSecret === undefined) return false;
			const components = (this.registry || {})[registerSecret];
			if(components){
				let elementContentComponent = false
				components.elementContainer.find(undefined, child => {
					if(!child.hasClass('base_accordion_head')){
						elementContentComponent = child
						return 'break'
					}
				})
				return elementContentComponent
			}
			return false
		},

		/**
		 * this function returns an array containing register secrets naturally ordered.
		 *
		 * @returns {Array.<*>}
		 */
		getSortedRegisterSecrets: function(){
			const staticRegisterSecrets = Object.keys(this.registry);
			const dynamicRegisterSecrets = [];
			let staticRegisterSecretIndex;
			utils.forEach(this.actions, action => {
				if(action.accordionConnection && action.accordionConnection.elementRegisterSecret != undefined){
					dynamicRegisterSecrets.push(action.accordionConnection.elementRegisterSecret);
					staticRegisterSecretIndex = utils.indexOf(staticRegisterSecrets, action.accordionConnection.elementRegisterSecret);
					if(staticRegisterSecretIndex >= 0) staticRegisterSecrets.splice(staticRegisterSecretIndex, 1);
				}
			});

			return staticRegisterSecrets.concat(dynamicRegisterSecrets);
		},

		updateStates: function(){
			// hide head if necessary
			if(utils.collectionSize(this.registry) < 2 && this.config.hideHeadContainingOneSingleElement){
				this.$.addClass('hideHead')
			} else {
				this.$.removeClass('hideHead')
			}
		}
	},

	hooks: {
		attach: function($element, options){
			if(utils.collectionSize(this.model.removeElementWhenReady) > 0){
				for(const registerSecret in this.model.removeElementWhenReady){
					this.removeElement(registerSecret)
				}
			}

			if(utils.collectionSize(this.registry) > 0){
				if(options.refresh){
					this.focusElement(this.model.activeRegisterSecret);
				}
				else if(this.config.startWithRegisterSecret && this.registry[this.config.startWithRegisterSecret]) {
					this.focusElement(this.config.startWithRegisterSecret);
				}
				else {
					this.focusElement(Object.keys(this.registry)[0]);
				}
			}

			this.updateStates()
		}
	},
};
